import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import "../styles/MemberLogin.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const AdminLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    try {
      const rolebasedUrl = process.env.REACT_APP_API_BASE_ROLE;
      console.log("Role-based URL:", rolebasedUrl);

      const response = await axios.post(`${rolebasedUrl}/admin-login`, {
        email,
        password,
      });

      const data = await response.json();
      console.log("Login Response:", data);
      if (!response.ok) {
        setErrorMsg(data.message || "Admin login failed");
      } else {
        // Store token and user data locally
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));

        // Check if user has admin privileges
        if (
          data.user &&
          (data.user.rolename === "SuperAdmin" ||
            data.user.rolename === "Secretary" ||
            data.user.rolename === "Admin" ||
            data.user.rolename === "Treasurer" ||
            data.user.rolename === "President" ||
            data.user.isAdmin)
        ) {
          const adminUrl = process.env.REACT_APP_API_ADMIN;
          console.log("Admin URL:", adminUrl);
          const userParam = encodeURIComponent(JSON.stringify(data.user));
          window.location.href = `${adminUrl}/dashboard?token=${data.token}&user=${userParam}`;
        } else {
          setErrorMsg("Unauthorized: Admin access required");
        }
      }
    } catch (err) {
      console.error("Login error:", err);
      setErrorMsg("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="member-login-section">
      <Container>
        <div className="login-box">
          <Row>
            <Col md={6} className="login-left mb-4 mb-md-0">
              <div className="login-form-container">
                <h4 className="login-title">Admin Login</h4>
              </div>
            </Col>

            <Col md={6}>
              <Form onSubmit={handleLogin}>
                {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

                <Form.Group controlId="formEmail" className="mb-4">
                  <Form.Label>Your Email ID</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formPassword" className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <div className="d-flex justify-content-between align-items-center mb-4">
                  <Link to="/forgot-password" className="custom-link">
                    Forgot Password ?
                  </Link>
                  <Form.Check
                    type="checkbox"
                    label="Remember Me"
                    className="remember-me"
                  />
                </div>

                <div className="text-center mb-3">
                  <Button
                    className="custom-btn"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Signing In..." : "SIGN IN"}
                  </Button>
                </div>

                <div className="bottom-text">
                  Click here to{" "}
                  <span
                    className="custom-link"
                    onClick={() => navigate("/terms-conditions")}
                    style={{ cursor: "pointer" }}
                  >
                    Register
                  </span>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default AdminLogin;
